/**
 * CyberSweep Audit Templates Configuration
 *
 * These templates define the due date calculations for different audit types.
 * Data sourced from Salesforce Cyber_Sweep_Audit_Temp__c object.
 */

import type { AuditTemplate } from '../types/auditTemplate';

export const AUDIT_TEMPLATES: AuditTemplate[] = [
  { id: 'tpl-2', name: 'Initial Deletion', phase1DueDateDays: 7, phase2DueDateDays: 0, phase2Required: false, checklistType: 'initial_deletion' },
  { id: 'tpl-1', name: 'Initial Audit', phase1DueDateDays: 7, phase2DueDateDays: 14, phase2Required: true, checklistType: 'comprehensive' },
  { id: 'tpl-3', name: 'Final Audit', phase1DueDateDays: 60, phase2DueDateDays: 14, phase2Required: true, checklistType: 'comprehensive' },
  { id: 'tpl-4', name: 'Quarter #1 Audit', phase1DueDateDays: 90, phase2DueDateDays: 15, phase2Required: true, checklistType: 'minimal' },
  { id: 'tpl-5', name: 'Quarter #2 Audit', phase1DueDateDays: 90, phase2DueDateDays: 15, phase2Required: true, checklistType: 'minimal' },
  { id: 'tpl-6', name: 'Quarter #3 Audit', phase1DueDateDays: 90, phase2DueDateDays: 15, phase2Required: true, checklistType: 'minimal' },
  { id: 'tpl-7', name: 'Quarter #4 Audit', phase1DueDateDays: 90, phase2DueDateDays: 15, phase2Required: true, checklistType: 'minimal' },
];

/**
 * Get an audit template by ID
 */
export const getAuditTemplateById = (id: string): AuditTemplate | undefined => {
  return AUDIT_TEMPLATES.find((t) => t.id === id);
};

/**
 * Get an audit template by name (case-insensitive)
 */
export const getAuditTemplateByName = (name: string): AuditTemplate | undefined => {
  const nameLower = name.toLowerCase();
  return AUDIT_TEMPLATES.find((t) => t.name.toLowerCase() === nameLower);
};
